/* نبأ: عرض الأسعار بعملة بلد الزائر، والدفع بالدرهم (قرار المستخدم 2026-10-21: عملة المتجر AED لإلغاء رسوم تحويل العملة 2%).
   - البلد من شوبيفاي (/browsing_context_suggestions.json)، وللاختبار ?naba_cc=KW.
   - العملات المربوطة بالدولار بأسعار ثابتة (الريال، الدرهم، القطري، البحريني، العُماني، الأردني)، وغيرها من أسعار شوبيفاي اليومية.
   - الريال يُقرّب لعدد صحيح فيطابق أسعار المتجر القديمة بالريال (240، 89...)؛ الزائر من الإمارات يرى الدرهم بصيغة عربية.
   - لا تنبيه «الدفع بالدرهم» في السلة ولا تحت الدفع السريع (قرار المستخدم 2026-10-21). */
(function () {
  var html = document.documentElement;
  function reveal() { html.classList.remove('naba-cc-wait'); }   // theme.liquid يخفي الأسعار لحظياً حتى لا يظهر «Dhs.» قبل التحويل
  if (!window.Shopify || !Shopify.currency || Shopify.currency.active !== 'AED') return reveal();
  var PEG = { USD: 3.6725, SAR: 3.6725 / 3.75, QAR: 3.6725 / 3.64, BHD: 3.6725 / 0.376, OMR: 3.6725 / 0.3845, JOD: 3.6725 / 0.709, AED: 1 };
  // قيمة الوحدة من كل عملة بالدرهم (للمربوطة)؛ غيرها يُحسب من Currency.rates (قيمة الوحدة بالدولار)
  var BY_COUNTRY = { SA: 'SAR', AE: 'AED', KW: 'KWD', QA: 'QAR', BH: 'BHD', OM: 'OMR', JO: 'JOD', EG: 'EGP', US: 'USD', GB: 'GBP',
    TR: 'TRY', MY: 'MYR', ID: 'IDR', PK: 'PKR', IN: 'INR', CA: 'CAD', AU: 'AUD', MA: 'MAD', DZ: 'DZD', TN: 'TND', IQ: 'IQD', LB: 'USD',
    SD: 'USD', YE: 'USD', LY: 'LYD', SG: 'SGD', NZ: 'NZD', CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', ZA: 'ZAR', NG: 'NGN', KE: 'KES',
    DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', BE: 'EUR', AT: 'EUR', IE: 'EUR', FI: 'EUR', PT: 'EUR', GR: 'EUR', LU: 'EUR',
    SK: 'EUR', SI: 'EUR', EE: 'EUR', LV: 'EUR', LT: 'EUR', MT: 'EUR', CY: 'EUR', HR: 'EUR' };
  var SYM = { SAR: 'ر.س', AED: 'د.إ', KWD: 'د.ك', QAR: 'ر.ق', BHD: 'د.ب', OMR: 'ر.ع', JOD: 'د.أ', EGP: 'ج.م', MAD: 'د.م', DZD: 'د.ج',
    TND: 'د.ت', IQD: 'د.ع', LYD: 'د.ل', USD: '$', EUR: '€', GBP: '£', TRY: '₺', INR: '₹' };
  var DEC = { KWD: 3, BHD: 3, OMR: 3, JOD: 3, USD: 2, EUR: 2, GBP: 2, CAD: 2, AUD: 2, CHF: 2, SGD: 2, NZD: 2 };
  var MONEY = /Dhs\.\s?([\d,]+(?:\.\d{1,2})?)(?:\s?AED)?/g;
  var store = { get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
                set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} } };

  function country() {
    var q = new URLSearchParams(location.search).get('naba_cc');
    if (q && /^[A-Za-z]{2}$/.test(q)) { store.set('naba_cc', q.toUpperCase()); return Promise.resolve(q.toUpperCase()); }
    var c = store.get('naba_cc');
    if (c) return Promise.resolve(c);
    return fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { var cc = (((j || {}).detected_values || {}).country || {}).handle || 'SA'; store.set('naba_cc', cc); return cc; })
      .catch(function () { return 'SA'; });                    // تعذّر التحديد ← الريال (أغلب العملاء)
  }

  function aedPerUnit(code) {
    if (PEG[code]) return Promise.resolve(PEG[code]);
    var load = window.Currency && Currency.rates ? Promise.resolve() : new Promise(function (ok) {
      var s = document.createElement('script');
      s.src = 'https://cdn.shopify.com/s/javascripts/currencies.js'; s.onload = ok; s.onerror = ok;
      document.head.appendChild(s);
    });
    return load.then(function () {
      var r = window.Currency && Currency.rates;
      return r && r[code] && r.AED ? r[code] / r.AED : null;    // قيمة الوحدة بالدولار ÷ قيمة الدرهم بالدولار
    });
  }

  function fmt(aed, code, perUnit) {
    var v = aed / perUnit, d = DEC[code] != null ? DEC[code] : 0;
    var n = d ? v.toFixed(d) : String(Math.round(v));
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(/(\.\d*?),/g, '$1');
    var s = SYM[code];
    return s ? (/^[$€£₺₹]$/.test(s) ? s + n : n + ' ' + s) : n + ' ' + code;
  }

  function convertText(node, code, perUnit) {
    var t = node.nodeValue;
    if (!t || t.indexOf('Dhs.') === -1) return;
    node.nodeValue = t.replace(MONEY, function (_, amt) { return fmt(parseFloat(amt.replace(/,/g, '')), code, perUnit); });
  }

  function walk(root, code, perUnit) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, { acceptNode: function (n) {
      var p = n.parentNode && n.parentNode.nodeName;
      return p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT; } });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (x) { convertText(x, code, perUnit); });
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll('*'), function (el) {
      if (el.shadowRoot) walk(el.shadowRoot, code, perUnit);      // ويدجت التطبيقات (إن كان ظلّه مفتوحاً)
    });
  }

  country().then(function (cc) {
    var code = BY_COUNTRY[cc] || 'AED';
    return aedPerUnit(code).then(function (per) {
      if (!per) { code = 'AED'; per = 1; }
      var run = function (root) { walk(root || document.body, code, per); };
      run();
      reveal();
      var pending = false;
      new MutationObserver(function () {
        if (pending) return; pending = true;
        requestAnimationFrame(function () { pending = false; run(); });
      }).observe(document.body, { childList: true, subtree: true, characterData: true });
      html.setAttribute('data-naba-currency', code);
      var st = document.createElement('style');                 // مسافة بين «الإجمالي التقديري» والمبلغ (component-totals.css يصفّر الهامش بـ«.totals > *»)
      st.textContent = '.totals>.totals__total-value,.totals>.totals__subtotal-value{margin-inline-start:.5em}';
      document.head.appendChild(st);
    });
  }).catch(reveal);
})();
